export const Paths = {
    home: "/",
    login: "/login",
    sections: "/sections",

    admin: "/admin",
    admin_users: "/admin/users",
    admin_categories: "/admin/categories",
    admin_objects: "/admin/objects",
    admin_object_ankets: "/admin/object_ankets",
    user: "/user",
    user_categories: "/user/categories",
    user_objects: "/user/objects",
    user_object_ankets: "/user/object_ankets",

} as const;
